<ml-timeline-ui [commands]="commands()"></ml-timeline-ui>